module.exports = __webpack_public_path__ + "static/logistics-delivery@2x-6221ec622bafa00f95d28b42644e858b.png";